import React from 'react'
import Form from '../components/Form'
import '../styles/about.css'
import { Helmet } from 'react-helmet'

function Contact() {
    return (
        <div id="contact-main">
            <Helmet>
                <title>Contact</title>
                <meta property="og:title" content="About Alpha Builders Seattle Home Remodeling Experts" />
                <meta name="description" content="Alpha Builders Seattle's trusted home remodeler, delivering expert renovations with quality craftsmanship and personalized service. Transform your space today!" />
                <meta name="keywords" content="alpha builders, home remodeling, kitchen remodeling, flooring services, roofing services, Remodeling " />
                <meta property="og:image" content="/favicon.ico" />
                <meta property="og:url" content="https://alphabuilders-wa.com/contact" />
                <meta property="og:type" content="website" />
            </Helmet>
            <header id='ctc-header'>
                <h1>CONTACT</h1>
            </header>


            <section id='contact-1'>


                <div className='ctc-1-card'>
                    <a className='ctc-1-card-link' href="tel:425-260-9444" >
                        <img src='/images/phone-large.png' alt='phone icon' />
                        <h2>PHONE</h2>
                        <h3>425-260-9444</h3>
                    </a>
                </div>







                <div className='ctc-1-card'>
                    <a className='ctc-1-card-link' href='mailto:Michael@alphabuilders-wa.com'>
                        <img src='/images/email-large.png' alt='email icon' />
                        <h2>EMAIL</h2>
                        <h3>Michael@alphabuilders-wa.com</h3>
                    </a>
                </div>



                <div className='ctc-1-card'>
                    <a className='ctc-1-card-link' href='https://www.facebook.com/profile.php?id=61566555421586' target='_blank'>
                        <img src='/images/fb.png' alt='facebook icon' />
                        <h2>Facebook</h2>
                        <h3>Alpha_Builders</h3>
                    </a>
                </div>



            </section>
            <section id='contact-2'>
                <Form />
            </section>
        </div>
    )
}

export default Contact